// Form values can be null (e.g. the password field), treated as empty.
export interface WelcomeTemplateTokenValues {
  domain?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  password?: string | null;
  groupEmails?: string[];
}

export type GroupsFormat = 'html' | 'text';

export const GROUPS_TOKEN = '{|Groups|}';

const TOKEN_REGEX = /\{\|([^|]+)\|\}/g;

function escapeHtml(value: string) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function sortedUniqueEmails(groupEmails: string[]) {
  return [...new Set(groupEmails.map((email) => email.trim()))]
    .filter((email) => email.length > 0)
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}

/**
 * Formats group emails sorted A-Z. `html` renders a bulleted list for the
 * email body, `text` renders a comma separated line for the subject.
 */
export function formatGroups(
  groupEmails: string[],
  format: GroupsFormat = 'html'
): string {
  const emails = sortedUniqueEmails(groupEmails);

  if (emails.length === 0) {
    return '';
  }

  if (format === 'text') {
    return emails.join(', ');
  }

  return `<ul>${emails
    .map((email) => `<li>${escapeHtml(email)}</li>`)
    .join('')}</ul>`;
}

export function replaceWelcomeTokens(
  text: string,
  values: WelcomeTemplateTokenValues,
  groupsFormat: GroupsFormat = 'html'
): string {
  return text.replace(TOKEN_REGEX, (match, variable: string): string => {
    switch (variable) {
      case 'Domain':
        return values.domain || '';
      case 'FirstName':
        return values.firstName || '';
      case 'LastName':
        return values.lastName || '';
      case 'Email':
        return values.email || '';
      case 'Password':
        return values.password || '';
      case 'Groups':
        return values.groupEmails === undefined
          ? match
          : formatGroups(values.groupEmails, groupsFormat);
      default:
        return match;
    }
  });
}
